
  var _styles = {
  "strategy-guide-container": {
    "width": "100%",
    "height": "100%",
    "position": "relative"
  },
  "strategy-guide-bg-image": {
    "width": "100%",
    "height": "100%"
  },
  "strategy-guide-button": {
    "width": "100%",
    "height": "0.64rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "absolute",
    "bottom": "0.2rem"
  },
  "strategy-guide-button-linear": {
    "width": "2.89333rem",
    "height": "100%",
    "borderRadius": "0.4rem",
    "overflow": "hidden",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "strategy-guide-button-text": {
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  